import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  FormControl,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import SimpleBackdrop from "../../utils/general.js";
import api from "../../utils/api.js";
import cogoToast from "cogo-toast";
import APIConstant from "../../utils/constant.js";
import { CommonConfig } from "../../CommonConfig.js";
import Loader from "components/Shared/Loader/Loader";

const ServiceCharges = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);

  const [serviceChargeList, setServiceChargeList] = useState([]);
  const [hsnList, setHsnList] = useState([]);
  const [gstList, setGstList] = useState([]);

  const [search, setSearch] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [masterId, setMasterId] = useState("");

  // Form Fields
  const [serviceName, setServiceName] = useState({
    name: "",
    err: false,
    errText: "",
  });

  const [hsnCode, setHsnCode] = useState({
    name: "",
    err: false,
    errText: "",
  });

  const [isGst, setIsGst] = useState(false);
  const [gst, setGst] = useState("");

  const rowsPerPage = CommonConfig.dataTableConfig.rowsPerPage;
  const rowsPerPageOptions = CommonConfig.dataTableConfig.rowsPerPageOptions;

  // ================== INIT ==================
  useEffect(() => {
    const data = localStorage.getItem("Infodata");
    const token = localStorage.getItem("Token");
    const pageAccess = localStorage.getItem("PageAccess");

    if (!token) {
      history.push("/login");
      return;
    }

    setUserId(data);
    setUserPageAccess(pageAccess || "");

    GetServiceChargeList(data);
    GetHSNList(data);
    GetGSTList(data);
  }, []);

  // ================== API CALLS ==================
  const GetServiceChargeList = async (UserId) => {
    api.post(APIConstant.path.GetServiceCharges, { UserId }).then((res) => {
      if (res.Success === 1) setServiceChargeList(res.Data);
    });
  };

  const GetHSNList = async (UserId) => {
    api.post(APIConstant.path.GetHSNCodeMaster, { UserId }).then((res) => {
      if (res.Success === 1) {
        setHsnList(res.Data);
      }
    });
  };

  const GetGSTList = async (UserId) => {
    api
      .post(APIConstant.path.GetMasterListByType, {
        ID: UserId,
        Type: "GST",
      })
      .then((res) => {
        if (res.Success === 1) {
          setGstList(
            res.Data.filter((x) => x.UserId !== "Admin").map((x) => ({
              label: x.name,
              value: x.value,
            }))
          );
        }
      });
  };

  const validation = () => {
    let formIsValid = true;
    if (CommonConfig.isEmpty(serviceName.name)) {
      setServiceName({
        name: "",
        err: true,
        errText: "Service Name is required.",
      });
      formIsValid = false;
    }
    if (CommonConfig.isEmpty(hsnCode.name)) {
      setHsnCode({
        name: "",
        err: true,
        errText: "HSN Code is required.",
      });
      formIsValid = false;
    }

    if (isGst) {
      if (CommonConfig.isEmpty(gst)) {
        cogoToast.error("Please enter GST");
      }
    }
    return formIsValid;
  };

  // ================== HANDLERS ==================
  const resetForm = () => {
    setServiceName({
      name: "",
      err: false,
      errText: "",
    });
    setHsnCode({
      name: "",
      err: false,
      errText: "",
    });
    setIsGst(false);
    setGst("");
    setMasterId("");
  };

  const handleOpen = (row) => {
    if (row) {
      setServiceName({ name: row.ServiceName, err: false, errText: "" });
      setHsnCode({ name: row.HSNCode, err: false, errText: "" });
      setIsGst(row.IsGst);
      setGst(row.GST);
      setMasterId(row.ServiceChargesId);
    }
    setOpenModal(true);
  };

  const handleSave = () => {
    if (validation()) {
      setLoading(true);
      const params = {
        ServiceChargesId: masterId,
        ServiceName: serviceName.name,
        HSNCode: hsnCode.name,
        HSNCodeName: hsnList.find((x) => x.value === hsnCode.name)?.label,
        IsGst: isGst,
        GST: isGst ? gst : "",
        GSTName: isGst ? gstList.find((x) => x.value === gst)?.label : "",
        UserId: userId,
      };

      api.post(APIConstant.path.AddUpdateServiceCharges, params).then((res) => {
        setLoading(false);
        if (res.Success === 1) {
          setOpenModal(false);
          resetForm();
          GetServiceChargeList(userId);
          cogoToast.success(res.Message);
        } else {
          cogoToast.error(res.Message);
        }
      });
    }
  };

  const handleDelete = () => {
    setLoading(true);
    api
      .post(APIConstant.path.DeleteServiceCharges, {
        ID: masterId,
        UserId: userId,
      })
      .then((res) => {
        setLoading(false);
        if (res.Success === 1) {
          setDeleteModal(false);
          setMasterId("");
          GetServiceChargeList(userId);
          cogoToast.success(res.Message);
        } else {
          cogoToast.error(res.Message);
        }
      });
  };

  // ================== TABLE ==================
  const actionTemplate = (row) => (
    <div className="bill-action icon-only-btn p-d-flex">
      {userPageAccess.includes("Edit Service Charges") ? (
        <div onClick={() => handleOpen(row)}>
          <i className="icon-editImage"></i>
        </div>
      ) : null}
      {userPageAccess.includes("Delete Service Charges") ? (
        <div
          onClick={() => {
            setMasterId(row.ServiceChargesId);
            setDeleteModal(true);
          }}
        >
          <i className="icon-delete"></i>
        </div>
      ) : null}
    </div>
  );

  const filteredList = serviceChargeList.filter(
    (x) =>
      x.ServiceName?.toLowerCase().includes(search.toLowerCase()) ||
      x.HSNCodeName?.toLowerCase().includes(search.toLowerCase())
  );

  const handleClose = () => {
    setOpenModal(false);
    resetForm();
  };

  const handleChange = (e, type) => {
    if (type === "serviceName") {
      if (CommonConfig.isEmpty(e.target.value)) {
        setServiceName({
          name: e.target.value,
          err: true,
          errText: `Please enter Service Name.`,
        });
      } else {
        setServiceName({
          name: e.target.value,
          err: false,
          errText: "",
        });
      }
    } else if (type === "gst") {
      setGst(e.value);
    } else if (type === "hsnCode") {
      if (CommonConfig.isObjectEmpty(e?.value)) {
        setHsnCode({
          name: "",
          err: true,
          errText: `Please select HSN Code.`,
        });
      } else {
        setHsnCode({
          name: e.value,
          err: false,
          errText: "",
        });
      }
    }
  };

  // ================== RENDER ==================
  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      {loading && <SimpleBackdrop />}

      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-truck"></i>
          <h2>Service Charges</h2>
        </div>
        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-as-center">
            <InputText
              type="search"
              placeholder="Global Search"
              onInput={(e) => setSearch(e.target.value)}
            />
          </div>
          {userPageAccess.includes("Add Service Charges") ? (
            <div className="e-add-btn" onClick={() => handleOpen(null)}>
              <i className="icon-add"></i>
            </div>
          ) : null}
        </div>
      </div>

      <hr />
      <div className="main-access-card-master">
        {userPageAccess.includes("View HSN Code") ? (
          <DataTable
            className="main-table table-td"
            value={filteredList}
            paginator
            rows={rowsPerPage}
            rowsPerPageOptions={rowsPerPageOptions}
            totalRecords={filteredList.length}
            emptyMessage="No records found"
            editMode="row"
            dataKey="id"
            responsiveLayout="scroll"
            globalFilter={search}
            responsive={false}
            resizableColumns={true}
            columnResizeMode="fit"
            scrollable={true}
            scrollWidth="auto"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          >
            <Column header="Sr.No" body={(_, p) => p.rowIndex + 1} />
            <Column field="ServiceName" header="Service Name" />
            <Column field="HSNCodeName" header="HSN Code" />
            <Column field="GSTName" header="GST" />
            <Column header="Action" body={actionTemplate} />
          </DataTable>
        ) : null}

        {/* ADD / EDIT MODAL */}
        <Dialog
          open={openModal}
          onClose={() => handleClose()}
          aria-labelledby="cha-form-dialog-title"
        >
          <DialogTitle
            id="cha-form-dialog-title"
            className="custom-dialog-header"
          >
            <div>{masterId ? "Edit" : "Add"} Service Charges </div>
            <div className="dialog-close" onClick={(e) => handleClose()}>
              <i className="icon-modal-close"></i>
            </div>
          </DialogTitle>
          <DialogContent className="CHA-dialog-content-area">
            <GridContainer>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  label="Service Name*"
                  value={serviceName.name}
                  error={serviceName.err}
                  helperText={serviceName.errText}
                  inputProps={{ maxLength: 50 }}
                  onChange={(e) => handleChange(e, "serviceName")}
                  fullWidth
                />
              </GridItem>

              <GridItem xs={12}>
                <div className="input-control select p-d-flex">
                  <FormControl fullWidth>
                    <Autocomplete
                      id="hsnCode"
                      name="hsnCode"
                      value={
                        hsnCode.name && hsnList.length
                          ? hsnList.filter((y) => y.value == hsnCode.name)[0]
                          : ""
                      }
                      options={hsnList}
                      getOptionLabel={(option) =>
                        option.label ? option.label : option
                      }
                      onChange={(e, value) => handleChange(value, "hsnCode")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          placeholder="HSN Code"
                          label="HSN Code"
                          error={hsnCode.err}
                          helperText={hsnCode.errText}
                        />
                      )}
                    />
                  </FormControl>
                </div>
              </GridItem>

              <GridItem xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isGst}
                      onChange={(e) => setIsGst(e.target.checked)}
                    />
                  }
                  label="GST Applicable"
                />
              </GridItem>

              {isGst && (
                <GridItem xs={12}>
                  <Autocomplete
                    id="gst"
                    name="gst"
                    value={
                      gst && gstList.length
                        ? gstList.filter((y) => y.value == gst)[0]
                        : ""
                    }
                    options={gstList}
                    getOptionLabel={(option) =>
                      option.label ? option.label : option
                    }
                    onChange={(e, value) => handleChange(value, "gst")}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        placeholder="GST"
                        label="GST"
                      />
                    )}
                  />
                </GridItem>
              )}
            </GridContainer>
          </DialogContent>
          <DialogActions className="p-p-0 dialog-footer1">
            <Button className="primary-btn1" onClick={() => handleClose()}>
              Cancel
            </Button>
            <Button className="primary-btn" onClick={handleSave}>
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        {/* DELETE MODAL */}
        <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
          <DialogTitle className="custom-dialog-header">
            Delete Service Charge
          </DialogTitle>
          <DialogContent>
            <h6>Are you sure want to delete?</h6>
          </DialogContent>
          <DialogActions>
            <Button
              className="primary-btn1"
              onClick={() => setDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button className="primary-btn" onClick={handleDelete}>
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default ServiceCharges;
